import { Controller } from "@hotwired/stimulus"

const TAB_ACTIVE = [
  "border-vivid-purple",
  "text-vivid-purple",
  "bg-vivid-purple/5",
]
const TAB_INACTIVE = [
  "border-transparent",
  "text-app-text-muted",
  "hover:border-app-border-strong",
  "hover:text-app-text",
]

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = {
    storageKey: { type: String, default: "" },
    defaultTab: { type: String, default: "" },
  }

  connect() {
    const stored = this._read()
    const firstId = this.defaultTabValue || this.tabTargets[0]?.dataset.tab
    const validIds = new Set(this.tabTargets.map((t) => t.dataset.tab))
    this._activate(stored && validIds.has(stored) ? stored : firstId)
  }

  selectTab(event) {
    const id = event.currentTarget.dataset.tab
    if (!id) return
    this._write(id)
    this._activate(id)
  }

  _activate(id) {
    this.tabTargets.forEach((btn) => {
      const active = btn.dataset.tab === id
      btn.classList.remove(...TAB_ACTIVE, ...TAB_INACTIVE)
      btn.classList.add(...(active ? TAB_ACTIVE : TAB_INACTIVE))
      btn.setAttribute("aria-selected", active ? "true" : "false")
    })
    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.tab !== id)
    })
  }

  _read() {
    if (!this.storageKeyValue) return null
    try {
      return sessionStorage.getItem(this.storageKeyValue)
    } catch (_) {
      return null
    }
  }

  _write(id) {
    if (!this.storageKeyValue) return
    try {
      sessionStorage.setItem(this.storageKeyValue, id)
    } catch (_) {
      /* ignore */
    }
  }
}
